import { render } from "./MediaPlayer.vue?vue&type=template&id=4ab3f2a8&scoped=true"
import script from "./MediaPlayer.vue?vue&type=script&lang=js"
export * from "./MediaPlayer.vue?vue&type=script&lang=js"

import "./MediaPlayer.vue?vue&type=style&index=0&id=4ab3f2a8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab3f2a8"]])

export default __exports__